import { render } from "./Objectifs.vue?vue&type=template&id=682c7b60"
import script from "./Objectifs.vue?vue&type=script&lang=ts"
export * from "./Objectifs.vue?vue&type=script&lang=ts"
script.render = render

export default script